import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { useAuth } from "../../provider/AuthProvider";
import UseTitle from "../../components/useTitle";
import "./SpellTemplates.scss";

const SpellTemplates = () => {
  // Définition du titre de la page
  UseTitle("Liste des sorts");

  const { isAdmin } = useAuth();

  const [listSpellTemplates, setListSpellTemplates] = useState([]);
  const [listInfos, setListInfos] = useState([]);

  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const [search, setSearch] = useState("");
  const [ordering, setOrdering] = useState({ field: "name", order: "asc" });
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    const fetchSpellTemplates = async () => {
      if (listSpellTemplates.length === 0) setIsInitialLoading(true);
      else setIsRefreshing(true);

      const orderingString = `${ordering.order === "asc" ? "" : "-"}${
        ordering.field
      }`;

      try {
        const response = await api.get(
          `/spelltemplate/?search=${search}&ordering=${orderingString}&page_size=${pageSize}&page=${page}`
        );
        setListSpellTemplates(response.data.results);
        setListInfos(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsInitialLoading(false);
        setIsRefreshing(false);
      }
    };

    fetchSpellTemplates();
  }, [search, ordering, page, pageSize]);

  return (
    <div className="spell-templates list-page">
      <div className="title">
        <h1>Liste des sorts</h1>
        {isAdmin && (
          <button className="bt" onClick={() => navigate("/spell/new")}>
            Ajouter un sort
          </button>
        )}
      </div>

      {/* Filtres */}
      <div className="filters">
        <div>
          <label htmlFor="search">Rechercher </label>
          <input
            type="text"
            id="search"
            name="search"
            value={search}
            onChange={(event) => (setSearch(event.target.value), setPage(1))}
          />
        </div>
        <div>
          <label htmlFor="orderingField">Trier par </label>
          <select
            id="orderingField"
            name="orderingField"
            value={ordering.field}
            onChange={(event) =>
              setOrdering({ ...ordering, field: event.target.value })
            }
          >
            <option value="name">Nom</option>
            <option value="domain">Domaine</option>
          </select>
        </div>
        <div>
          <label htmlFor="orderingDirection">Trier par </label>
          <select
            id="orderingDirection"
            name="orderingDirection"
            value={ordering.order}
            onChange={(event) =>
              setOrdering({ ...ordering, order: event.target.value })
            }
          >
            <option value="asc">Ascendant</option>
            <option value="desc">Descendant</option>
          </select>
        </div>
        <div>
          <label htmlFor="pageSize">Nombre d'affichage </label>
          <select
            id="pageSize"
            name="pageSize"
            value={pageSize}
            onChange={(event) => (setPageSize(event.target.value), setPage(1))}
          >
            <option value="6">6</option>
            <option value="12">12</option>
            <option value="24">24</option>
            <option value="48">48</option>
          </select>
        </div>

        {listSpellTemplates.length != 0 && <h2>Sorts ({listInfos.count})</h2>}
      </div>

      {/* Chargment Initial */}
      {isInitialLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}

      {/* Chargement des sorts */}
      {!isInitialLoading &&
        (listSpellTemplates.length === 0 ? (
          <div className="no-data">
            <p>
              <strong>Aucun sort trouvé</strong>
            </p>
          </div>
        ) : (
          <div className={`list-div ${isRefreshing ? "loading" : ""}`}>
            {listSpellTemplates.map((spellTemplate) => (
              <NavLink
                key={spellTemplate.id}
                className="list-card"
                to={`/spell/${spellTemplate.id}`}
              >
                {ordering.field === "name" ? (
                  <>
                    <h3>{spellTemplate.name}</h3>
                    <h4>{spellTemplate.domain}</h4>
                  </>
                ) : (
                  <>
                    <h4>{spellTemplate.domain}</h4>
                    <h3>{spellTemplate.name}</h3>
                  </>
                )}

                <div>
                  <small>
                    (
                    {spellTemplate.attributes.map((attribute, index) => (
                      <span className="attributes" key={index}>
                        {index !== 0 && ", "}
                        {attribute.full_name}
                      </span>
                    ))}
                    )
                  </small>
                </div>
              </NavLink>
            ))}
          </div>
        ))}

      {/* Pagination */}
      {!isInitialLoading && listSpellTemplates.length > 0 && (
        <div className="pagination">
          <button
            className={page <= 1 ? "bt disabled" : "bt"}
            onClick={() => handlePageChange(page - 1)}
            disabled={page <= 1}
          >
            &lt;&lt;
          </button>
          <span>
            {page} / {Math.ceil(listInfos.count / pageSize)}
          </span>
          <button
            className={
              page >= Math.ceil(listInfos.count / pageSize)
                ? "bt disabled"
                : "bt"
            }
            onClick={() => handlePageChange(page + 1)}
            disabled={page >= Math.ceil(listInfos.count / pageSize)}
          >
            &gt;&gt;
          </button>
        </div>
      )}
    </div>
  );
};

export default SpellTemplates;
